(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hf-footer"] && !Shopify.designMode) return;
  try {
    
  const companyMedia = window.matchMedia('(min-width: 750px)');
  const syncCompanyDetails = () => {
    document.querySelectorAll('.hf-footer__information--company').forEach((details) => {
      details.open = companyMedia.matches;
    });
  };
  const initCompanyDetails = () => {
    syncCompanyDetails();
    companyMedia.addEventListener('change', syncCompanyDetails);
    document.addEventListener('shopify:section:load', syncCompanyDetails);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompanyDetails, { once: true });
  } else {
    initCompanyDetails();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
